export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'cacl(100vh - 20px)',
        paddingBottom: '20px'
    },
    cardContainer: {
        padding: '20px 20px 0px 20px',
        marginLeft: '30px'
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    errorText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
        color: 'red'
    },
})